import type { EntityCard } from '../types';

// The entities whose alias cluster the reconcile panel should fetch: every
// present, non-retired card. Retired (soft-deleted/merged) entities are excluded
// — on merge their Alias edges are repointed to the canonical, so their own
// /aliased_entities cluster is empty and the endpoint 404s on the retired id
// (ONCALL-692). Dropping them here suppresses both the bulk and the lazy
// per-pill fetch, and keeps a retired entity out of "Group N" membership.
export function aliasableEntityIds(
  cards: Array<EntityCard | null | undefined>
): number[] {
  return cards
    .filter((e): e is EntityCard => !!e && !e.deleted)
    .map((e) => e.id);
}
